<p-toast></p-toast>
<div class="p-5 bg-white experience-listings-table-wrap">
	<p-table
		styleClass="experience-listings-table"
		[tableStyle]="{ 'table-layout': 'fixed', width: '100%' }"
		[value]="listings"
		[lazy]="true"
		(onLazyLoad)="handleLazyLoad($event)"
		[sortField]="query.sortField"
		[sortOrder]="query.sortOrder"
		[paginator]="true"
		[totalRecords]="totalRecords"
		[loading]="loading"
		[first]="query.skip"
		[rows]="query.take"
		[rowsPerPageOptions]="rowsPerPageOptions"
		[showCurrentPageReport]="true"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		paginatorStyleClass="paginator-left"
	>
		<ng-template pTemplate="caption">
			<div class="flex justify-content-between align-items-center mb-3">
				<h2 class="text-xl font-bold m-0">Experience Listings</h2>
			</div>
		</ng-template>

		<ng-template pTemplate="header">
			<tr>
				<ng-container *ngFor="let col of columns; let i = index">
					<th
						*ngIf="(i < columns.length - 1 || canUpdateListingStatus) && col.sortField"
						[style.width]="col.width"
						[pSortableColumn]="col.sortField"
					>
						{{ col.label }}<p-sortIcon [field]="col.sortField" />
					</th>
					<th *ngIf="(i < columns.length - 1 || canUpdateListingStatus) && !col.sortField" [style.width]="col.width">
						{{ col.label }}
					</th>
				</ng-container>
			</tr>
			<tr>
				<th [style.width]="columns[0].width">
					<input
						type="number"
						class="p-inputtext p-component w-full"
						[(ngModel)]="filter.id"
						(ngModelChange)="handleFilterChange()"
						placeholder="Type here"
					/>
				</th>
				<th [style.width]="columns[1].width">
					<input
						type="text"
						class="p-inputtext p-component w-full"
						[(ngModel)]="filter.title"
						(ngModelChange)="handleFilterChange()"
						placeholder="Type here"
					/>
				</th>
				<th [style.width]="columns[2].width">
					<input
						type="text"
						class="p-inputtext p-component w-full"
						[(ngModel)]="filter.tourOperatorName"
						(ngModelChange)="handleFilterChange()"
						placeholder="Type here"
					/>
				</th>
				<th [style.width]="columns[3].width">
					<input
						type="text"
						class="p-inputtext p-component w-full"
						[(ngModel)]="filter.locationName"
						(ngModelChange)="handleFilterChange()"
						placeholder="Type here"
					/>
				</th>
				<th [style.width]="columns[4].width">
					<input
						type="text"
						class="p-inputtext p-component w-full"
						[(ngModel)]="filter.categoryName"
						(ngModelChange)="handleFilterChange()"
						placeholder="Type here"
					/>
				</th>
				<th [style.width]="columns[5].width">
					<input
						type="number"
						class="p-inputtext p-component w-full"
						[(ngModel)]="filter.basePrice"
						(ngModelChange)="handleFilterChange()"
						placeholder="Type here"
					/>
				</th>
				<th [style.width]="columns[6].width">
					<p-dropdown
						[(ngModel)]="filter.status"
						[options]="statusFilterOptions"
						(onChange)="handleFilterChange()"
						placeholder="Select"
						[showClear]="true"
						optionLabel="label"
						optionValue="value"
						appendTo="body"
						styleClass="w-full"
					></p-dropdown>
				</th>
				<th *ngIf="canUpdateListingStatus" [style.width]="columns[7].width"></th>
			</tr>
		</ng-template>

		<ng-template pTemplate="body" let-row>
			<tr>
				<td [style.width]="columns[0].width">{{ row.id }}</td>
				<td class="cell-ellipsis" [style.width]="columns[1].width" [title]="row.title">{{ row.title }}</td>
				<td class="cell-ellipsis" [style.width]="columns[2].width" [title]="row.tourOperatorName">
					{{ row.tourOperatorName || '—' }}
				</td>
				<td class="cell-ellipsis" [style.width]="columns[3].width" [title]="row.locationName">
					{{ row.locationName || '—' }}
				</td>
				<td class="cell-ellipsis" [style.width]="columns[4].width" [title]="row.categoryName">
					{{ row.categoryName || '—' }}
				</td>
				<td [style.width]="columns[5].width">₱{{ row.basePrice }}</td>
				<td [style.width]="columns[6].width">
					<span
						class="listing-card__status"
						[class.listing-card__status--active]="row.status === ListingStatus.Active"
						[class.listing-card__status--draft]="row.status === ListingStatus.Draft"
						[class.listing-card__status--inactive]="row.status === ListingStatus.Inactive"
						[class.listing-card__status--approved]="row.status === ListingStatus.Approved"
						[class.listing-card__status--rejected]="row.status === ListingStatus.Rejected"
						[class.listing-card__status--in-review]="row.status === ListingStatus.InReview"
					>
						{{ row.statusName }}
					</span>
				</td>
				<td *ngIf="canUpdateListingStatus" [style.width]="columns[7].width">
					<p-dropdown
						[options]="row.actionStatusOptions"
						optionLabel="label"
						optionValue="value"
						[ngModel]="row.status"
						(ngModelChange)="onStatusChange(row, $event)"
						[disabled]="updatingListingId === row.id || row.actionStatusOptions.length <= 1"
						[showClear]="false"
						appendTo="body"
						styleClass="w-full experience-listings-row-dropdown"
						placeholder="Status"
					></p-dropdown>
				</td>
			</tr>
		</ng-template>

		<ng-template pTemplate="emptymessage">
			<tr>
				<td [attr.colspan]="canUpdateListingStatus ? columns.length : columns.length - 1" class="text-center">
					No listings found.
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
